import { clearStoredCart } from './cartStorage.js';
import { publishCustomerCartReset } from '../../../shared/crossTab/customerCrossTab.js';

export interface ResetShopCartInput {
  readonly tenantCode: string;
  readonly kioskId: number;
  readonly source: string;
}

type ShopCartMemoryClearCallback = (input: ResetShopCartInput) => void;

const memoryClearCallbacks = new Set<ShopCartMemoryClearCallback>();

/** Register in-tab cart memory reset (e.g. `useShopCart` state). Returns unsubscribe. */
export function registerShopCartMemoryClear(callback: ShopCartMemoryClearCallback): () => void {
  memoryClearCallbacks.add(callback);
  return (): void => {
    memoryClearCallbacks.delete(callback);
  };
}

/** Idempotent: sessionStorage + cross-tab bus + registered in-memory hooks. */
export function resetShopCart(input: ResetShopCartInput): void {
  clearStoredCart(input.tenantCode, input.kioskId);
  publishCustomerCartReset(input.tenantCode, input.kioskId, input.source);
  for (const callback of memoryClearCallbacks) {
    callback(input);
  }
}
